import {Component, HTMLAttributes, ReactNode} from "react";
import {GameOption} from './Game';
import {Autocomplete, Box, Container, TextField} from '@mui/material';
import {GameStatus, Guess} from '../content/GameContext';

interface InputProps<Schema> {
    handleInput: (selectedOption: GameOption<Schema> | null) => void;
    options: GameOption<Schema>[];
    totalGuesses: number;
    previousGuesses: Guess<Schema>[];
    gameStatus: GameStatus;
}

interface InputState<Schema> {
    selected: GameOption<Schema> | null;
    inputValue: string;
}

class GuessInput<Schema> extends Component<InputProps<Schema>, InputState<Schema>> {
    constructor(props: InputProps<Schema>) {
        super(props);
        this.state = {
            inputValue: '',
            selected: null
        };
    }

    private getRenderedOption = (props: HTMLAttributes<HTMLLIElement>, option: any) => {
        return <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...props}>
            {/*<img*/}
            {/*    loading="lazy"*/}
            {/*    width="20"*/}
            {/*    src={`https://flagcdn.com/w20/ca.png`}*/}
            {/*    srcSet={`https://flagcdn.com/w40/ca.png 2x`}*/}
            {/*    alt=""*/}
            {/*/>*/}
            {option.label}
        </Box>;
    };

    private shouldShowOptions = () => {
        if (this.props.options.length > 10000) {
            return this.state.inputValue.length < 2;
        }
        return this.state.inputValue.length < 1;
    };

    override render(): ReactNode {
        // TODO: https://www.botsplash.com/post/optimize-your-react-select-component-to-smoothly-render-10k-data
        let placeholder: string;
        if (this.props.gameStatus === GameStatus.InProgress) {
            placeholder = `Guess ${this.props.previousGuesses.length + 1} of ${this.props.totalGuesses}`;
        } else if (this.props.gameStatus === GameStatus.Success) {
            placeholder = `You solved it in ${this.props.previousGuesses.length}!`;
        } else {
            placeholder = "Game Over";
        }

        return <Container sx={{width: "80%", maxWidth: "800px"}}>
            <Autocomplete
                options={this.shouldShowOptions() ? [] : this.props.options}
                value={this.state.selected}
                onChange={(event, input) => {
                    this.props.handleInput(input);
                    this.setState(() => ({
                        inputValue: '',
                        selected: null
                    }));
                }}
                inputValue={this.state.inputValue}
                onInputChange={(event, newInputValue) => {
                    this.setState((prevState) => ({
                        ...prevState,
                        inputValue: newInputValue
                    }));
                }}
                disabled={this.props.gameStatus !== GameStatus.InProgress}
                autoHighlight={true}
                renderInput={(params) => <TextField {...params} label={placeholder}/>}
                isOptionEqualToValue={(option, value) => (option.label.toLowerCase() === value.label.toLowerCase())}
                getOptionLabel={(option) => option.label}
                renderOption={this.getRenderedOption}
                loading={this.shouldShowOptions()}
                loadingText={"Start Typing..."}
            />
        </Container>;
    }
}

export default GuessInput;
